import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

import { companyApi }                      from "src/store/services/admin/company";
import type { ICompanyResponse }           from "src/store/services/admin/company/interfaces/responses.interface";
import type { RootState }                  from "src/store/store";
import { RequestStateEnum }                from "src/types";

type TCompanyState = {
  value: {
    profile: { data: ICompanyResponse | null; state: RequestStateEnum };
  };
};

const initialState: TCompanyState = { value: { profile: { data: null, state: RequestStateEnum.NODATA } }, };

const slice = createSlice({
  name    : "adminCompanyApi",
  initialState,
  reducers: {
    setCompanyProfile: (state,
      { payload: { value: { profile }, }, }: PayloadAction<TCompanyState>) => {
      state.value.profile = profile;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(companyApi.endpoints.getCompanyProfile.matchPending,
      (state) => {
        state.value.profile.state = RequestStateEnum.LOADING;
      });
    builder.addMatcher(companyApi.endpoints.getCompanyProfile.matchRejected,
      (state) => {
        state.value.profile.state = RequestStateEnum.FAILED;
      });
    builder.addMatcher(companyApi.endpoints.getCompanyProfile.matchFulfilled,
      (state, { payload }) => {
        state.value.profile.state = RequestStateEnum.FULLFILLED;
        state.value.profile.data = payload;
      });
  },
});

export const { setCompanyProfile } = slice.actions;

export const getCompanyProfile = (state: RootState) =>
  state.adminCompany.value.profile;

export const { reducer: adminCompanyReducer } = slice;
